export const translations = {
  nl: {
    nav: {
      services: 'Diensten',
      mailing: 'Direct Mail',
      caseStudies: 'Case Studies',
      about: 'Over',
      contact: 'Contact',
      cta: 'Boek Kennismakingsgesprek'
    },
    cookieConsent: {
      title: 'Cookievoorkeuren',
      message: 'We gebruiken analytische cookies (Google Analytics) om te begrijpen hoe bezoekers onze website gebruiken. Deze cookies worden alleen geplaatst als je daarmee instemt.',
      accept: 'Accepteren',
      decline: 'Weigeren'
    },
    hero: {
      badge: 'Vertrouwd door onderwijsinstellingen en bedrijven',
      titleLine1: 'Intelligente automatisering',
      titleLine2: 'op maat',
      subtitle1: 'Agents, assistenten en integraties die passen bij jouw workflows—en jouw data in eigen huis houden',
      subtitle2: '',
      subtitle3: '',
      ctaPrimary: 'Boek een kennismakingsgesprek',
      ctaSecondary: 'Ontdek onze diensten'
    },
    trust: {
      item1: 'Private-ready (on-prem)',
      item2: 'Python/LangGraph/LangChain',
      item3: 'In productie 12+ maanden'
    },
    services: {
      badge: 'Onze specialiteiten',
      title: 'Maatwerkoplossingen voor jouw uitdagingen',
      subtitle: 'Integraties, automatisering en gepersonaliseerde systemen die precies doen wat jij nodig hebt.',
      viewAll: 'Bekijk Alle Diensten',
      cards: {
        s1Title: 'Systeemintegratie & Automatisering',
        s1Desc: 'Naadloze koppelingen tussen CRM, planning en andere systemen met automatische workflows.',
        s2Title: 'Gepersonaliseerde Oplossingen',
        s2Desc: 'Op maat gemaakte systemen die precies aansluiten bij de behoeften van jouw organisatie.',
        s3Title: 'Intelligente Data-verwerking',
        s3Desc: 'Automatische analyse en verwerking van data met AI voor betere besluitvorming.',
        s4Title: 'On-premise & Privacy-first',
        s4Desc: 'Lokale implementaties die volledige controle en privacy van gevoelige gegevens garanderen.'
      }
    },
    featured: {
      badge: 'Succesverhalen',
      title: 'Uitgelichte Oplossingen',
      subtitle: 'Echte implementaties die meetbare resultaten leveren.',
      learnMore: 'Lees meer',
      viewAll: 'Bekijk Alle Case Studies',
      cases: {
        c1Title: 'Assessment en Feedback Systeem',
        c1Client: 'Technische Universiteit Eindhoven',
        c1Desc: 'Geautomatiseerde beoordeling en feedback voor studentenwerk met on-premise LLM en data-privacy.',
        c1Tags: ['Onderwijs', 'On‑Premise', 'Automatisering'],
        c2Title: 'Gepersonaliseerd Stadsgids Systeem',
        c2Client: 'Maps Untold',
        c2Desc: 'Automatische gepersonaliseerde stadsgidsen voor reizigers, gebrand naar zakelijke partners.',
        c2Tags: ['Personalisatie', 'Reistech'],
        c3Title: 'CRM ↔ Planning Integratie Platform',
        c3Client: 'Renewable Partners',
        c3Desc: 'Volledig geautomatiseerde klant-onboarding, facturatie en communicatie via een geïntegreerd platform.',
        c3Tags: ['Integratie', 'Automatisering', 'Klantbeheer']
      }
    },
    cta: {
      badge: 'Klaar voor een oplossing op maat?',
      title: 'Laten we jouw uitdaging samen aanpakken',
      subtitleP1: 'Ontdek hoe onze expertise in systeemintegratie, automatisering en gepersonaliseerde oplossingen ',
      subtitleP2: 'jouw organisatie kan transformeren',
      subtitleP3: ' met behoud van privacy',
      ctaPrimary: 'Plan een vrijblijvend gesprek',
      ctaSecondary: 'Of stuur ons een e-mail'
    },
    pillars: {
      items: {
        p1Title: 'Praktisch',
        p1Desc: 'Geen ruis of dikke rapporten—snelle, concrete resultaten.',
        p2Title: 'Schaalbaar',
        p2Desc: 'Van pilot naar productie met monitoring en betrouwbaarheid.',
        p3Title: 'Betaalbaar',
        p3Desc: 'Slimme keuzes, geen dure trajecten met onnodige tussenlagen.'
      }
    },
    processHome: {
      badge: 'Onze aanpak',
      title: 'Van uitdaging naar oplossing',
      subtitle: 'Een bewezen proces voor het ontwikkelen van effectieve maatwerkoplossingen.',
      steps: {
        s1: { title: 'Analyse & Ontdekking', desc: 'We begrijpen jouw specifieke behoeften en uitdagingen.' },
        s2: { title: 'Oplossingsontwerp', desc: 'Een op maat gemaakte strategie voor jouw unieke situatie.' },
        s3: { title: 'Ontwikkeling', desc: 'Bouwen van integraties, automatisering en gepersonaliseerde systemen.' },
        s4: { title: 'Implementatie & Training', desc: 'Soepele overgangen met volledige ondersteuning voor jouw team.' },
        s5: { title: 'Doorlopende optimalisatie', desc: 'Voortdurende verbetering op basis van resultaten en feedback.' }
      }
    },
    servicesPage: {
      heroTitle: 'Maatwerkoplossingen voor Jouw Uitdagingen',
      heroSub: 'Wij ontwikkelen intelligente systemen en integraties die perfect aansluiten bij jouw specifieke behoeften.',
      introText: 'Elk project begint met jouw huidige stack. We integreren wat je vandaag gebruikt, ontwerpen agents rond jouw workflows, en deployen privacy-first—on-prem of in jouw cloud.',
      items: {
        s1: {
          title: 'AI-gedreven Automatisering',
          description: 'Intelligente agents die complexe taken zelfstandig uitvoeren.',
          details: 'Wij ontwikkelen geavanceerde AI-agents die repetitieve taken overnemen en complexe workflows automatiseren. Deze intelligente systemen kunnen zelfstandig beslissingen nemen, informatie verzamelen en verwerken, en acties uitvoeren zonder menselijke tussenkomst.',
          features: ['Autonome taakuitvoering', 'Intelligente besluitvorming', 'Zelfstandige informatieverwerking', 'Adaptief leren', 'Naadloze integratie met bestaande systemen']
        },
        s2: {
          title: 'Gepersonaliseerde Content Systemen',
          description: 'Op maat gemaakte oplossingen voor content verzameling en personalisatie.',
          details: 'We ontwikkelen systemen die automatisch relevante content verzamelen, analyseren en personaliseren. Deze oplossingen kunnen grote hoeveelheden informatie verwerken en op maat gemaakte aanbevelingen genereren die perfect aansluiten bij specifieke voorkeuren en behoeften.',
          features: ['Automatische content verzameling', 'Geavanceerde personalisatie-algoritmes', 'Multimodale content-analyse', 'Behoud van branding', 'Schaalbare aanbevelingssystemen']
        },
        s3: {
          title: 'Intelligente Data-verwerking',
          description: 'Automatische analyse en verwerking van data voor betere besluitvorming.',
          details: 'Onze AI-systemen kunnen grote hoeveelheden data verzamelen, analyseren en structureren. Van geavanceerde content scraping tot multimodale analyse met computer vision - we zorgen ervoor dat je waardevolle inzichten krijgt uit complexe en ongestructureerde data.',
          features: ['Geavanceerde dataverzameling', 'AI-gestuurde content categorisatie', 'Multimodale analyse', 'Automatische data-extractie', 'Realtime verwerking en inzichten']
        },
        s4: {
          title: 'On-premise & Privacy-first LLM Oplossingen',
          description: 'Lokale AI-implementaties met volledige controle over gevoelige data.',
          details: 'We ontwikkelen geavanceerde LLM-oplossingen die volledig lokaal draaien, zonder externe data-overdracht. Deze systemen bieden alle voordelen van moderne AI-technologie, maar dan met 100% data-privacy en volledige controle - perfect voor onderwijs, gezondheidszorg of financiële instellingen.',
          features: ['100% data-privacy', 'Lokale LLM-implementaties', 'Geen externe data-overdracht', 'Volledige controle over je data', 'Compliance met privacywetgeving']
        },
        s5: {
          title: 'Systeemintegratie & Middleware',
          description: 'Naadloze koppelingen tussen verschillende systemen en platforms.',
          details: 'Naast onze AI-oplossingen bouwen we ook robuuste integraties tussen verschillende systemen. Van CRM naar planning, van facturatie naar klantcommunicatie - we zorgen ervoor dat al je systemen naadloos samenwerken en data consistent blijft over je hele stack.',
          features: ['Naadloze systeemkoppelingen', 'Automatische data-synchronisatie', 'Conflictoplossing', 'Realtime updates', 'Betrouwbare middleware']
        }
      },
      ctaTitle: 'Klaar voor een oplossing op maat?',
      ctaSub: 'Laten we jouw uitdaging samen aanpakken en een systeem ontwikkelen dat perfect aansluit bij jouw behoeften.',
      ctaButton: 'Plan een vrijblijvend gesprek'
    },
    aboutPage: {
      heroTitle: 'Waarom AgentTailor.ai',
      heroSub: 'Maatwerk agents en automatiseringen die in jouw tools passen—privacy-first en meetbaar waardevol.',
      heroCta: 'Plan een kennismaking',
      whyExistsTitle: 'Waarom AgentTailor bestaat',
      whyExistsContent: 'We helpen MKB-bedrijven echte waarde uit AI te halen door agents en automatiseringen te koppelen aan de systemen die je al gebruikt—CRM, planning, communicatie en dataopslag—terwijl gevoelige data in eigen huis blijft. Maatwerk boven sjablonen. Privacy by design. Integratie eerst.',
      patternTitle: 'Het patroon dat we bleven zien',
      patternContent: 'Teams krijgen generieke AI-tools verkocht die niet passen bij hun workflows, niet praten met hun stack, en data versturen naar plaatsen die ze niet kunnen controleren. Pilots stagneren. Adoptie loopt achter. Veiligheidszorgen nemen toe. We bouwden AgentTailor om dit probleem op te lossen met op maat agents, sterke integraties en on-prem of private deployments.',
      whyWorksTitle: 'Waarom het werkt',
      whyWorksCards: [
        {
          title: 'Maatwerk i.p.v. sjabloon',
          description: 'Agent rond jouw proces.'
        },
        {
          title: 'Integraties die doorstromen',
          description: 'CRM, planning, comms als één geheel.'
        },
        {
          title: 'Privacy by design',
          description: 'On-prem of jouw cloud. Data blijft thuis.'
        }
      ],
      proofBar: {
        title: 'Waarom werken met ons?',
        metric1: { number: '6+ jaar', label: 'ervaring in AI en automatisering' },
        metric2: { number: '3+ jaar', label: 'ervaring in Agentic and conversational AI' },
        metric3: { number: '100%', label: 'data privacy' }
      },
      valuesTitle: 'Onze Waarden',
      valuesSub: 'De principes achter elke oplossing die we bouwen.',
      values: {
        outcomeFirst: {
          title: 'Outcome-First',
          description: 'We meten succes in uren bespaard, fouten verlaagd en minder handoffs—niet in complexiteit of buzzwords.'
        },
        privacyByDesign: {
          title: 'Privacy by Design',
          description: 'Uw data blijft waar die hoort—binnen uw infrastructuur. On‑premises of in uw VPC.'
        },
        productionReliability: {
          title: 'Productiebetrouwbaarheid',
          description: 'Geen demo\'s alleen. Oplossingen draaien 12+ maanden met monitoring, SLA\'s en goede foutafhandeling.'
        }
      },
      processTitle: 'Onze Werkwijze',
      processSub: 'Heldere scopes, korte cycli, productieklare resultaten.',
      process: [
        { step: '01', title: 'Discovery', description: 'We starten bij uw grootste pijnpunten—handwerk, repetitie en systeemsilo\'s.' },
        { step: '02', title: 'Design', description: 'Duidelijke scopes, snelle iteraties. Geen over‑engineering of onnodige complexiteit.' },
        { step: '03', title: 'Build', description: 'Productieklare code met Python, LangGraph en LangChain. Getest, gemonitord, gedocumenteerd.' },
        { step: '04', title: 'Run', description: 'We blijven aan boord: monitoren, onderhouden en doorontwikkelen met uw groei.' }
      ],
      techTitle: 'Onze Tech Stack',
      techSub: 'Bewezen technologieën voor betrouwbare AI-oplossingen.',
      techItems: [
        { title: 'Python', sub: 'Kern taal' },
        { title: 'LangGraph', sub: 'Agent workflows' },
        { title: 'LangChain', sub: 'LLM applicaties' },
        { title: 'Docker', sub: 'Deploy' }
      ],
      ctaTitle: 'Samenwerken?',
      ctaSub: 'Bespreek uw uitdagingen en ontdek hoe we tijd besparen mét dataprivacy.',
      ctaButton: 'Boek Kennismakingsgesprek'
    },
    contactPage: {
      heroTitle: 'Aan de slag',
      heroSub: 'Klaar om workflows te automatiseren? Laten we uw behoeften bespreken.',
      quickContact: 'Snel Contact',
      form: {
        name: 'Naam *',
        company: 'Bedrijf',
        email: 'E‑mail *',
        question: 'Bericht',
        placeholder: 'Waar kunnen we u mee helpen?',
        submit: 'Verstuur Bericht',
        sending: 'Versturen…',
        success: 'Bedankt! We nemen zo snel mogelijk contact met u op.',
        error: 'Er ging iets mis. Probeer het opnieuw of mail naar info@agenttailor.ai.'
      },
      discoveryTitle: 'Plan een Kennismakingsgesprek',
      discoveryText: 'Plan 30 minuten om uw behoeften te bespreken en te zien of er een match is.',
      calendly: 'Calendly‑integratie komt hier',
      schedule: 'Plan Gesprek',
      bullets: ['Sessie van 30 minuten', 'Geen sales—wel oplossingen', 'Gratis automation‑scan'],
      infoTitle: 'Contactgegevens',
      emailHint: 'info@agenttailor.ai',
      location: 'Het Eeuwsel 57 \n5612 AS Eindhoven\nEindhoven University of Technology campus',
      faqTitle: 'Veelgestelde Vragen',
      faqs: [
        { q: 'Hoe lang duurt een gemiddeld project?', a: 'Meestal 4–8 weken met duidelijke milestones en snelle wins.' },
        { q: 'Werken jullie met kleine bedrijven?', a: 'Zeker. We zijn gericht op MKB met pragmatische oplossingen.' },
        { q: 'Kunnen jullie onze data privé houden?', a: 'Ja. On‑premises of in uw VPC. Data verlaat uw infra niet. DPA mogelijk.' },
        { q: 'Wat gebeurt er na oplevering?', a: 'Monitoring en support. Veel systemen draaien 12+ maanden stabiel.' }
      ]
    },
    caseStudiesPage: {
      heroTitle: 'Case Studies',
      heroSub: 'Praktische winst van op maat gemaakte agents en sterke integraties—gebouwd met meetbare resultaten en dataprivacy in gedachten.',
      cases: [
        { title: 'Assessment en Feedback Systeem', client: 'Technische Universiteit Eindhoven', context: 'De faculteit Electrical Engineering had een systeem nodig om automatisch studentenwerk te beoordelen voor Machine Learning for Signal Processing. Docenten wilden studenten vrijheid geven om te experimenteren, maar het nakijken werd te complex en arbeidsintensief door de vele mogelijke oplossingsrichtingen.', approach: 'Ontwikkeling van een geïntegreerd systeem met:\n• Virtuele testomgeving voor code-uitvoering\n• Parser voor studentcode en documenten\n• Syntax- en performancecontrole\n• On-premise LLM voor kwalitatieve analyse\n• Automatische vergelijking met modeloplossingen\n• Gedetailleerde feedback op basis van rubrics', result: 'Studenten ontvangen gedetailleerde, gepersonaliseerde feedback op grote schaal zonder extra belasting voor docenten. Het systeem beoordeelt zowel kwantitatief (cijfers) als kwalitatief (verbeterpunten) met 100% data-privacy omdat alles lokaal blijft. Docenten kunnen zich nu richten op inhoudelijke begeleiding in plaats van repetitief nakijkwerk.', tags: ['Onderwijs', 'Code Review', 'On‑Premise', 'Automatisering'], metrics: ['100% dataprivacy met lokale LLMs', ' 7x snellere feedbackcyclus (van 7 dagen naar 1 dag)', '+90% tijdsbesparing voor docenten (van vele uren naar 1 uur voor alle studenten)'] },
        { title: 'EXAMAI: Formatieve Mondeling Examenvoorbereiding', client: 'Technische Universiteit Eindhoven', context: 'Mondeling examens zijn een gewaardeerd onderdeel van veel TU/e-cursussen en bieden directe interactie tussen studenten en examinatoren. Ze missen echter vaak structuur, consistentie en objectieve kwaliteitscontrole. Voor Advanced Actuator Design hadden docenten een schaalbare manier nodig om studenten mondelinge assessments te laten oefenen, met behoud van eerlijkheid en betekenisvolle feedback, zonder extra nakijkwerk.', approach: 'Ontwerp en implementatie van een AI-ondersteund conversationeel examinesysteem met:\n• Taalmodellen getraind op cursusspecifiek materiaal, afgestemd op leerdoelen\n• Real-time interactieve dialogen waarin de AI cursusrelevante vragen stelt en vervolgvragen aanpast\n• Gestructureerde, gedetailleerde feedback om verbeterpunten te identificeren\n• Formatieve assessmentmodus waarmee studenten kunnen oefenen vóór formele evaluatie\n• Privacy-first architectuur met respect voor transparantie en inclusiviteit', result: 'Studenten oefenen mondelinge examens via dynamische AI-gesprekken en ontvangen consistente, gestructureerde feedback die dieper leren ondersteunt. Docenten krijgen een gestandaardiseerd kader dat subjectiviteit vermindert en de voorbereidingsworkload verlaagt. De pilot binnen Advanced Actuator Design levert praktische inzichten op in technische, pedagogische en ethische aspecten van AI-ondersteunde assessment, ter ondersteuning van docenten, niet ter vervanging.', tags: ['Onderwijs', 'Conversationele AI', 'Formatieve Assessment', 'On‑Premise'], metrics: ['Uitgerold voor Advanced Actuator Design bij TU/e', 'Real-time adaptieve mondelinge examdialogen', 'Gestructureerde formatieve feedback vóór formeel examen', 'Privacy-first ontwerp voor transparante, inclusieve assessment'] },
        { title: 'Gepersonaliseerd Stadsgids Systeem', client: 'Maps Untold', context: 'Maps Untold moest reizigers voorzien van gepersonaliseerde lokale aanbevelingen die volledig gebrand zouden zijn voor hun zakelijke partners met minimale handmatige inspanning. Het handmatig creëren van aangepaste stadsgidsen voor elke bezoeker was onmogelijk op te schalen.', approach: 'Ontwikkeling van een geavanceerde datapipeline met:\n• Dynamische zoekmachine-integratie om lokale gelegenheden en attracties te ontdekken\n• Selenium-gebaseerde geautomatiseerde browser voor content-extractie van bedrijfswebsites\n• Gespecialiseerde crawlers voor menu-URLs, openingstijden en sociale media profielen\n• Multimodaal AI-model voor beeldkwaliteitsbeoordeling en contentcategorisatie\n• Personalisatie-engine om reizigersvoorkeuren te matchen met lokale aanbevelingen', result: 'Het systeem voorziet reizigers automatisch van gepersonaliseerde stadsgidsen met hoogwaardige lokale aanbevelingen, allemaal gebrand naar de zakelijke partners van Maps Untold. Reizigers ontvangen aangepaste aanbevelingen op basis van hun voorkeuren, terwijl zakelijke partners hun branding behouden zonder extra inspanning, wat snelle opschaling naar meerdere steden wereldwijd mogelijk maakt.', tags: ['Personalisatie', 'Automatisering', 'Reistech', 'AI Beeldherkenning'], metrics: ['+95% relevantie van aanbevelingen', '3x the amount of data to work with'] },
        { title: 'CRM ↔ Planning Integratie Platform', client: 'Renewable Partners', context: 'Renewable Partners had te maken met inefficiënte handmatige processen voor klantenbeheer, planning en facturatie. Dubbele gegevensinvoer leidde tot fouten en vertragingen, terwijl het onboarden van nieuwe klanten tijdrovend was en de communicatie inconsistent verliep.', approach: 'Ontwikkeling van een uitgebreid integratie-ecosysteem met:\n• Naadloze koppeling tussen CRM en planningstool\n• Geautomatiseerd onboardingsproces voor nieuwe klanten\n• Interne dashboards voor efficiënt klantenbeheer\n• Volledig geautomatiseerd facturatiesysteem\n• Geautomatiseerde klantcommunicatie via SMS\n• Webtools voor het opvragen van energielabels', result: 'Het systeem heeft het klantbeheerproces volledig gestroomlijnd. Nieuwe klanten worden nu automatisch geonboard, alle relevante informatie wordt tijdig en consistent gecommuniceerd via SMS, en de facturatie verloopt volledig automatisch. Medewerkers kunnen via intuïtieve dashboards eenvoudig klantgegevens beheren, terwijl klanten zelf energielabels kunnen opvragen via de website.', tags: ['Integratie', 'CRM', 'Automatisering', 'Klantbeheer'], metrics: ['100% geautomatiseerde onboarding', '90% minder administratieve fouten', '75% tijdsbesparing in facturatieproces', 'Verbeterde klanttevredenheid door consistente communicatie'] },
        { title: 'Privacy-first HR Assistent', client: 'Dr. Pitt', context: 'HR-afdelingen worstelen met het snel vinden van relevante informatie in de uitgebreide jungle van HR-documenten die zich in de loop van de tijd ontwikkelt. Medewerkers stellen vaak dezelfde vragen over beleid, procedures en regelgeving, wat HR-teams belast met repetitieve informatievragen.', approach: 'Ontwikkeling van een privacy-first RAG-systeem met:\n• Lokaal gehoste LLM op VPS voor volledige data-controle\n• Geavanceerde document parsing en indexering van HR-documentatie\n• Gelaagde toegangscontrole waarbij elke gebruiker toegang heeft tot informatie behorend bij hun tier\n• Semantische zoekmachine door HR-kennisbank\n• Intelligente antwoordgeneratie met bronverwijzingen', result: 'HR-teams worden ontlast van repetitieve informatievragen en kunnen zich richten op strategische HR-taken. Medewerkers krijgen direct toegang tot accurate, gepersonaliseerde informatie uit HR-documenten, waarbij privacy en compliance gewaarborgd blijven door lokale hosting. Het systeem respecteert organisatiehiërarchie door gelaagde informatietoegang.', tags: ['HR', 'RAG', 'Privacy-first', 'On-Premise'], metrics: ['80% minder repetitieve HR-vragen', '95% snellere informatievoorziening', '100% data-privacy door lokale hosting', 'Gelaagde toegangscontrole voor alle gebruikers'] },
        { title: 'Multi-Agent Blog Generatie Platform', client: 'AgentTailor.ai (Intern)', context: 'Het handmatig schrijven van blogs voor content marketing is tijdrovend en vereist constante research, schrijfvaardigheid en merkbewustzijn. Het onderhouden van een consistente blog met relevante, SEO-geoptimaliseerde content die aansluit bij de merkwaarden en doelgroep was een uitdaging die veel tijd kostte van het kernteam.', approach: 'Ontwikkeling van een multi-agent systeem met gespecialiseerde agents:\n• Search Agent: Voert Google-zoekopdrachten uit via Serper API voor actuele informatie\n• Crawler Agent: Analyseert bestaande website content en blogposts voor merkgevoeligheid\n• Writing Agent: Genereert blogs op basis van doelgroep, merkwaarden, en content format\n• Image Generator: Creëert passende visuals voor de gegenereerde content\n• Supervisory Agent: Coördineert alle agents en waarborgt kwaliteit en merkconsistentie', result: 'Het platform genereert automatisch hoogwaardige blogs die perfect aansluiten bij merkwaarden, doelgroep en gewenste tone-of-voice. Elk blog wordt gegenereerd met specifieke parameters zoals lezerstijd, distributiekanaal en CTA-integratie. Het systeem houdt rekening met bestaande content om duplicatie te voorkomen en zorgt voor SEO-optimalisatie door actuele zoekresultaten te integreren.', tags: ['Multi-Agent', 'Content Marketing', 'AI Writing', 'SEO'], metrics: ['90% tijdsbesparing in content creatie', 'Consistente merkboodschap in alle content', 'Automatische SEO-optimalisatie', 'Gepersonaliseerde content voor elke doelgroep'] }
      ],
      blueprintTitle: 'Weet u niet waar te beginnen?',
      blueprintSub: 'Vraag het Automation Blueprint sample aan en vind uw beste kansen.',
      blueprintCta: 'Download Automation Blueprint'
    },
    mailingPage: {
      heroBadge: 'Data-gedreven direct mail',
      heroCta: 'Plan een kennismaking',
      segmentToggle: {
        label: 'Kies je doelgroep',
        recentSales: 'Recent verkocht',
        propertyData: 'Woningdata algemeen'
      },
      segments: {
        recentSales: {
          heroTitle: 'Exclusieve leads op het koopmoment',
          heroSub: 'Wij vinden recent verkochte woningen op basis van energielabels en andere woningdata, en sturen namens jou gepersonaliseerde brieven: exclusieve leads met volledige woninginformatie.',
          opportunity: {
            badge: 'Jouw werkgebied',
            title: 'Kansen in jouw regio',
            subtitle: 'geschikte koopwoningen zijn vorige week in jouw werkgebied verkocht, grondgebonden, met matig energielabel. Nieuwe bewoners, precies op het moment dat de beslissing valt.',
            regionLabel: 'Voorbeeldregio',
            regionName: 'Utrecht-Oost',
            statNumber: '22',
            statLabel: 'geschikte koopwoningen deze week',
            tableTitle: 'Waar de kansen zitten, jouw werkgebied deze week',
            tableHeaders: ['Gemeente', 'Verkocht', 'Kansen (label ≤ C)', 'Kans-score / week'],
            rows: [
              { municipality: 'Utrecht', sold: 12, opportunities: 9, score: 84 },
              { municipality: 'Zeist', sold: 6, opportunities: 5, score: 72 },
              { municipality: 'Bunnik', sold: 4, opportunities: 3, score: 65 },
              { municipality: 'Houten', sold: 4, opportunities: 3, score: 61 }
            ],
            footnote: 'Kans-score per week = gewogen index op verkoopvolume, aandeel matig energielabel en woonoppervlak. Hoger = grotere kans deze week. Voorbeelddata ter illustratie.'
          },
          valueProp: {
            badge: 'In beeld vóór de offerte-ronde',
            title: 'Die huishoudens, exclusief bij jou op de mat.',
            body: 'Wie net koopt, geeft de eerste 6 maanden 5× meer uit aan woningverbetering en zoekt pas dán een dienstverlener op marktplaatsen of Google. Wij sturen namens jóu een persoonlijke brief, dáárvóór. Reageert de bewoner, dan is de lead exclusief van jou, mét woningdata. Jij hoeft alleen op te nemen als ze bellen.'
          },
          letterMockup: {
            title: 'Wat de huiseigenaar ontvangt',
            addressee: 'Aan de bewoners van',
            address: 'Dorpsstraat 12, Utrecht',
            heading: 'Welkom in uw nieuwe woning',
            body: 'Gefeliciteerd met uw woning aan de Dorpsstraat. Een verhuizing is hét moment voor uw woning, zeker bij een woning uit 1974, energielabel D.\n\nMet de juiste aanpassingen verlaagt u uw energierekening aanzienlijk én komt u in aanmerking voor subsidies.',
            signature: 'Hartelijke groet,\nLokale Specialist BV, uw lokale partner'
          },
          leadMockup: {
            title: 'Wat jij terugkrijgt',
            leadName: 'Fam. de Vries',
            leadBadge: 'Nieuwe lead',
            fields: [
              { label: 'Adres', value: 'Dorpsstraat 12, Utrecht' },
              { label: 'Bouwjaar', value: '1974' },
              { label: 'Woonoppervlak', value: '118 m²' },
              { label: 'Energielabel', value: 'D · geschikt' },
              { label: 'Vraagprijs', value: '€ 465.000' },
              { label: 'Interesse', value: 'Woningverbetering' }
            ],
            exclusiveNote: 'Exclusief van jou. Eén woning, één dienstverlener. Geen bieder-oorlog met 4 anderen zoals bij marktplaatsen.'
          }
        },
        propertyData: {
          heroTitle: 'Gerichte brieven op basis van woningdata',
          heroSub: 'Wij selecteren woningen in jouw werkgebied op energielabel, perceelgegevens en andere openbare bronnen, en sturen gepersonaliseerde brieven naar eigenaren die passen bij jouw dienst.',
          opportunity: {
            badge: 'Jouw selectiecriteria',
            title: 'Woningen die bij jou passen',
            subtitle: 'woningen in jouw werkgebied voldoen aan jouw filters, bijvoorbeeld matig energielabel, geschikt perceeloppervlak of specifieke woningkenmerken. Gericht bereik zonder koud bellen.',
            regionLabel: 'Voorbeeldregio',
            regionName: 'Alblasserwaard',
            statNumber: '847',
            statLabel: 'passende woningen',
            tableTitle: 'Verdeling per gemeente, jouw selectie deze week',
            tableHeaders: ['Gemeente', 'Woningen', 'Match (label ≤ C)', 'Kans-score / week'],
            rows: [
              { municipality: 'Alblasserdam', sold: 312, opportunities: 89, score: 78 },
              { municipality: 'Hardinxveld-Giessendam', sold: 198, opportunities: 54, score: 71 },
              { municipality: 'Papendrecht', sold: 176, opportunities: 48, score: 68 },
              { municipality: 'Sliedrecht', sold: 161, opportunities: 41, score: 64 }
            ],
            footnote: 'Kans-score per week = gewogen index op aantal matches, energielabel en perceel-/woningkenmerken. Voorbeelddata ter illustratie. Filters stemmen we af in het eerste gesprek.'
          },
          valueProp: {
            badge: 'Data in plaats van koud bellen',
            title: 'Duizenden woningen, één gerichte brief per adres.',
            body: 'In plaats van willekeurig acquireren, filter je op woningkenmerken die ertoe doen: energielabel, perceeloppervlak, bouwjaar of regio. Wij verrijken adressen met openbare data, schrijven de brief op maat en voegen een QR-code toe. Scan jij mee, dan weet je precies wie geïnteresseerd is, exclusief voor jou.'
          },
          letterMockup: {
            title: 'Wat de huiseigenaar ontvangt',
            addressee: 'Aan de bewoners van',
            address: 'Klaproosstraat 2, Bleskensgraaf',
            heading: 'Uw woning heeft meer potentieel',
            body: 'Uw woning aan de Klaproosstraat valt op in onze analyse: perceeloppervlak 350 m², energielabel C. Dat biedt kansen voor verduurzaming én waardestijging.\n\nScan de QR-code voor een vrijblijvende analyse op maat van uw situatie.',
            signature: 'Hartelijke groet,\nLokale Specialist BV, uw lokale partner'
          },
          leadMockup: {
            title: 'Wat jij terugkrijgt',
            leadName: 'Fam. Jansen',
            leadBadge: 'QR-scan · lead',
            fields: [
              { label: 'Adres', value: 'Klaproosstraat 2, Bleskensgraaf' },
              { label: 'Perceeloppervlak', value: '350 m²' },
              { label: 'Energielabel', value: 'C · geschikt' },
              { label: 'Onbebouwd deel', value: '350 m²' },
              { label: 'Vraagprijs', value: '€ 385.000' },
              { label: 'Interesse', value: 'Via QR-scan' }
            ],
            exclusiveNote: 'Exclusief van jou. Eén woning, één dienstverlener. Lead direct na QR-scan, mét alle beschikbare woningdata.'
          }
        }
      },
      fit: {
        badge: 'Voor wie dit werkt',
        title: 'Herken je dit?',
        items: [
          'Je zoekt actief nieuwe klanten',
          'Je koopt nu leads op marktplaatsen of via Google',
          'Je richt je op particuliere huiseigenaren'
        ]
      },
      comparison: {
        badge: 'Vergelijk kanalen',
        title: 'Wat je per lead betaalt, en wat je ervoor krijgt',
        subtitle: 'Niet de goedkoopste klik. Wél de enige die exclusief én op tijd komt.',
        headers: ['Kanaal', 'Wat je krijgt', 'Gedeeld?', 'Wat het kost'],
        rows: [
          { channel: 'Werkspot / Homedeal', gets: 'Formulier-lead, koud. Betaalt ook als je niet wint', shared: 'met 3–5', cost: '€40–80 /lead' },
          { channel: 'Google Ads', gets: 'Klik → formulier, geen woningdata', shared: 'n.v.t.', cost: '€80–140 /lead' },
          { channel: 'Beursstand (VSK e.d.)', gets: 'Zichtbaarheid, gedeelde aandacht', shared: 'massaal', cost: '€3.000+ /beurs' },
          { channel: 'Eigen verkoopteam', gets: 'Zelf bellen / acquireren', shared: 'n.v.t.', cost: '€4.000+ /mnd' },
          { channel: 'Agent Tailor', gets: 'Exclusieve lead + woningdata, op het juiste moment', shared: 'nee, alleen jij', cost: '€3,75 /brief', highlight: true }
        ],
        footnote: 'Werkspot/Google uit markt-benchmarks; beurs/verkoopteam = indicaties. Agent Tailor = €3,75 per brief (excl.).'
      },
      roi: {
        badge: 'Reken zelf uit',
        title: 'Van brieven naar omzet',
        subtitle: 'Stel het aantal brieven en opdrachtwaarde in en zie direct wat het oplevert.',
        lettersLabel: 'Brieven / maand',
        scanRateLabel: 'QR-scan rate: 16%',
        scanRateHint: 'Met QR-code op de brief bereiken we 16% scan rate',
        jobValueLabel: 'Gemiddelde opdrachtwaarde',
        jobValuePlaceholder: '6000',
        metrics: [
          { key: 'scans', label: 'QR-scans / maand' },
          { key: 'customers', label: 'nieuwe klanten / maand' },
          { key: 'letterCost', label: 'briefkosten / maand' },
          { key: 'revenue', label: 'extra omzet / jaar' }
        ],
        conversionNote: 'Conversie: 2% van verstuurde brieven wordt klant',
        assumptions: 'In het pilot-gesprek stemmen we conversie en opdrachtwaarde af op jouw eigen cijfers.'
      },
      division: {
        badge: 'Hoe het werkt',
        title: 'Wij doen het zoek- en datawerk, jij het menselijke.',
        body: 'Onze techniek vindt de woningen en schrijft de brieven. Jij houdt je tijd voor het adviesgesprek en de uitvoering. Een brief op de mat: geen advertentie die wordt weggeklikt, gericht op het adres, niet op een algoritme.'
      },
      pilot: {
        badge: 'Pilot · exclusief in jouw gebied',
        title: 'Start met een pilot op maat',
        body: 'In een eerste gesprek brengen we jouw werkgebied, doelgroep en capaciteit in kaart. Daarna stellen we een pilot samen die past bij wat jij nodig hebt en aankunt.',
        bullets: [
          'Reactie binnen 1 werkdag',
          'Geen verplichtingen',
          'Volume en planning in overleg'
        ],
        cta: 'Plan een kennismaking'
      },
      disclaimer: 'Voorbeelddata ter illustratie. Bedrijfsnaam, adres en cijfers zijn fictief. Brieven gericht aan "de bewoners van", op basis van openbare bronnen.'
    }
  },
  en: {
    nav: {
      services: 'Services',
      mailing: 'Direct Mail',
      caseStudies: 'Case Studies',
      about: 'About',
      contact: 'Contact',
      cta: 'Book Discovery Call'
    },
    cookieConsent: {
      title: 'Cookie preferences',
      message: 'We use analytics cookies (Google Analytics) to understand how visitors use our website. These cookies are only set if you consent.',
      accept: 'Accept',
      decline: 'Decline'
    },
    hero: {
      badge: 'Trusted by educational institutions and businesses',
      titleLine1: 'Intelligent automation',
      titleLine2: 'tailored for you',
      subtitle1: 'system integrations',
      subtitle2: 'personalized solutions',
      subtitle3: 'data-driven results',
      ctaPrimary: 'Book a discovery call',
      ctaSecondary: 'Explore our services'
    },
    trust: {
      item1: 'Private-ready (on-prem)',
      item2: 'Python/LangGraph/LangChain',
      item3: 'Running in production 12+ months'
    },
    services: {
      badge: 'Our Specialties',
      title: 'Custom Solutions for Your Challenges',
      subtitle: 'Integrations, automation, and personalized systems that do exactly what you need.',
      viewAll: 'View All Services',
      cards: {
        s1Title: 'System Integration & Automation',
        s1Desc: 'Seamless connections between CRM, planning and other systems with automated workflows.',
        s2Title: 'Personalized Solutions',
        s2Desc: 'Custom-built systems that perfectly match the needs of your organization.',
        s3Title: 'Intelligent Data Processing',
        s3Desc: 'Automatic analysis and processing of data with AI for better decision making.',
        s4Title: 'On-premise & Privacy-first',
        s4Desc: 'Local implementations that ensure complete control and privacy of sensitive data.'
      }
    },
    featured: {
      badge: 'Success Stories',
      title: 'Featured Solutions',
      subtitle: 'Real implementations delivering measurable outcomes.',
      learnMore: 'Learn more',
      viewAll: 'View All Case Studies',
      cases: {
        c1Title: 'Assessment and Feedback System',
        c1Client: 'Eindhoven University of Technology',
        c1Desc: 'Automated assessment and feedback for student work with on-premise LLM and data privacy.',
        c1Tags: ['Education', 'On-Premise', 'Automation'],
        c2Title: 'Personalized City Guide System',
        c2Client: 'Maps Untold',
        c2Desc: 'Automatic personalized city guides for travelers, fully branded to business partners.',
        c2Tags: ['Personalization', 'Travel Tech'],
        c3Title: 'CRM ↔ Planning Integration Platform',
        c3Client: 'Renewable Partners',
        c3Desc: 'Fully automated customer onboarding, billing, and communication through an integrated platform.',
        c3Tags: ['Integration', 'Automation', 'Customer Management']
      }
    },
    cta: {
      badge: 'Ready for a tailored solution?',
      title: "Let's tackle your challenge together",
      subtitleP1: 'Discover how our expertise in system integration, automation, and personalized solutions can ',
      subtitleP2: 'transform your organization',
      subtitleP3: ' while maintaining privacy',
      ctaPrimary: 'Schedule a free consultation',
      ctaSecondary: 'Or send us an email'
    },
    pillars: {
      items: {
        p1Title: 'Practical',
        p1Desc: 'No noise or thick reports—clear, concrete outcomes fast.',
        p2Title: 'Scalable',
        p2Desc: 'From pilot to production with monitoring and reliability.',
        p3Title: 'Affordable',
        p3Desc: 'Smart choices, not expensive projects with extra layers.'
      }
    },
    processHome: {
      badge: 'Our approach',
      title: 'From challenge to solution',
      subtitle: 'A proven process for developing effective custom solutions.',
      steps: {
        s1: { title: 'Analysis & Discovery', desc: 'We understand your specific needs and challenges.' },
        s2: { title: 'Solution Design', desc: 'A tailored strategy for your unique situation.' },
        s3: { title: 'Development', desc: 'Building integrations, automation, and personalized systems.' },
        s4: { title: 'Implementation & Training', desc: 'Smooth transitions with full support for your team.' },
        s5: { title: 'Continuous Optimization', desc: 'Ongoing improvement based on results and feedback.' }
      }
    },
    servicesPage: {
      heroTitle: 'Custom Solutions for Your Challenges',
      heroSub: 'We develop intelligent systems and integrations that perfectly match your specific needs.',
      introText: 'Every project starts with your current stack. We integrate what you use today, design agents around your workflows, and deploy privacy-first—on-prem or in your cloud.',
      items: {
        s1: {
          title: 'AI-driven Automation',
          description: 'Intelligent agents that independently perform complex tasks.',
          details: 'We develop advanced AI agents that take over repetitive tasks and automate complex workflows. These intelligent systems can make decisions independently, gather and process information, and execute actions without human intervention.',
          features: ['Autonomous task execution', 'Intelligent decision making', 'Independent information processing', 'Adaptive learning', 'Seamless integration with existing systems']
        },
        s2: {
          title: 'Personalized Content Systems',
          description: 'Custom-built solutions for content collection and personalization.',
          details: 'We develop systems that automatically collect, analyze, and personalize relevant content. These solutions can process large amounts of information and generate tailored recommendations that perfectly match specific preferences and needs.',
          features: ['Automatic content collection', 'Advanced personalization algorithms', 'Multimodal content analysis', 'Brand preservation', 'Scalable recommendation systems']
        },
        s3: {
          title: 'Intelligent Data Processing',
          description: 'Automatic analysis and processing of data for better decision making.',
          details: 'Our AI systems can collect, analyze, and structure large amounts of data. From advanced content scraping to multimodal analysis with computer vision - we ensure you get valuable insights from complex and unstructured data.',
          features: ['Advanced data collection', 'AI-driven content categorization', 'Multimodal analysis', 'Automatic data extraction', 'Real-time processing and insights']
        },
        s4: {
          title: 'On-premise & Privacy-first LLM Solutions',
          description: 'Local AI implementations with complete control over sensitive data.',
          details: 'We develop advanced LLM solutions that run entirely locally, without external data transfer. These systems offer all the benefits of modern AI technology, but with 100% data privacy and complete control - perfect for education, healthcare, or financial institutions.',
          features: ['100% data privacy', 'Local LLM implementations', 'No external data transfer', 'Complete control over your data', 'Compliance with privacy regulations']
        },
        s5: {
          title: 'System Integration & Middleware',
          description: 'Seamless connections between different systems and platforms.',
          details: 'In addition to our AI solutions, we also build robust integrations between different systems. From CRM to planning, from billing to customer communication - we ensure all your systems work together seamlessly and data remains consistent across your entire stack.',
          features: ['Seamless system connections', 'Automatic data synchronization', 'Conflict resolution', 'Real-time updates', 'Reliable middleware']
        }
      },
      ctaTitle: 'Ready for a tailored solution?',
      ctaSub: "Let's tackle your challenge together and develop a system that perfectly meets your needs.",
      ctaButton: 'Schedule a free consultation'
    },
    aboutPage: {
      heroTitle: 'Why AgentTailor.ai',
      heroSub: 'Custom agents and automations that fit your tools—privacy-first and measurably valuable.',
      heroCta: 'Schedule a discovery call',
      whyExistsTitle: 'Why AgentTailor exists',
      whyExistsContent: 'We help SMBs get real value from AI by stitching agents and automations into the systems you already run—CRM, planning, comms, and data stores—while keeping sensitive data in-house. Tailored over templated. Privacy by design. Integration first.',
      patternTitle: 'The pattern we kept seeing',
      patternContent: 'Teams are sold generic AI tools that don\'t fit their workflows, don\'t talk to their stack, and ship data to places they can\'t control. Pilots stall. Adoption lags. Security worries rise. We built AgentTailor to flip that script with custom agents, tight integrations, and on-prem or private deployments.',
      whyWorksTitle: 'Why it works',
      whyWorksCards: [
        {
          title: 'Custom over template',
          description: 'Agent around your process.'
        },
        {
          title: 'Integrations that flow',
          description: 'CRM, planning, comms as one whole.'
        },
        {
          title: 'Privacy by design',
          description: 'On-prem or your cloud. Data stays home.'
        }
      ],
      proofBar: {
        title: 'Why work with us?',
        metric1: { number: '6+ years', label: 'Experience in AI and automation' },
        metric2: { number: '3+ years', label: 'Experience in Agentic and conversational AI' },
        metric3: { number: '100%', label: 'data privacy' }
      },
      valuesTitle: 'Our Values',
      valuesSub: 'The principles that guide every solution we build.',
      values: {
        outcomeFirst: {
          title: 'Outcome-First',
          description: 'We measure success by hours saved, errors reduced, and handoffs eliminated—not by complexity or buzzwords.'
        },
        privacyByDesign: {
          title: 'Privacy by Design',
          description: 'Your data stays where it belongs—in your infrastructure. On-prem or in your VPC.'
        },
        productionReliability: {
          title: 'Production-Grade Reliability',
          description: 'We don\'t just build demos. Our solutions run for 12+ months with monitoring, SLAs, and error handling.'
        }
      },
      processTitle: 'How We Work',
      processSub: 'Clear scopes, short cycles, production-grade results.',
      process: [
        { step: '01', title: 'Discovery', description: 'We start with your biggest pain points—manual work, repetition, and system gaps.' },
        { step: '02', title: 'Design', description: 'Clear scopes, fast iteration. No over-engineering or unnecessary complexity.' },
        { step: '03', title: 'Build', description: 'Production-ready code with Python, LangGraph, and LangChain. Tested, monitored, documented.' },
        { step: '04', title: 'Run', description: 'We don\'t disappear. We monitor, maintain, and evolve with your growth.' }
      ],
      techTitle: 'Our Tech Stack',
      techSub: 'Production-proven technologies for reliable AI solutions.',
      techItems: [
        { title: 'Python', sub: 'Core language' },
        { title: 'LangGraph', sub: 'Agent workflows' },
        { title: 'LangChain', sub: 'LLM applications' },
        { title: 'Docker', sub: 'Deployment' }
      ],
      ctaTitle: 'Ready to work together?',
      ctaSub: "Let's discuss your challenges and see how we can save time while keeping your data private.",
      ctaButton: 'Book Discovery Call'
    },
    contactPage: {
      heroTitle: 'Get Started',
      heroSub: "Ready to automate your workflows? Let's discuss your needs.",
      quickContact: 'Quick Contact',
      form: {
        name: 'Name *',
        company: 'Company',
        email: 'Email *',
        question: 'Message',
        placeholder: 'How can we help you?',
        submit: 'Send Message',
        sending: 'Sending…',
        success: 'Thank you! We will get back to you as soon as possible.',
        error: 'Something went wrong. Please try again or email info@agenttailor.ai.'
      },
      discoveryTitle: 'Book a Discovery Call',
      discoveryText: "Schedule a 30-minute conversation to discuss your needs and fit.",
      calendly: 'Calendly integration would go here',
      schedule: 'Schedule Call',
      bullets: ['30-minute discovery session', 'No sales pitch, just solutions', 'Free automation assessment'],
      infoTitle: 'Contact Information',
      emailHint: 'info@agenttailor.ai',
      location: 'Het Eeuwsel 57 \n 5612 AS Eindhoven\nEindhoven University of Technology campus',
      faqTitle: 'Frequently Asked Questions',
      faqs: [
        { q: 'How long does a typical project take?', a: 'Most projects are delivered in 4–8 weeks with clear milestones.' },
        { q: 'Do you work with small businesses?', a: 'Absolutely. We specialize in SMBs with pragmatic solutions.' },
        { q: 'Can you keep our data private?', a: 'Yes. On-prem or in your VPC. Data never leaves your infra. DPA available.' },
        { q: 'What happens after delivery?', a: 'Ongoing monitoring and support. Many systems run 12+ months reliably.' }
      ]
    },
    caseStudiesPage: {
      heroTitle: 'Case Studies',
      heroSub: 'Practical wins from tailored agents and tight integrations—built with measurable outcomes and data privacy in mind.',
      cases: [
        { title: 'Assessment and Feedback System', client: 'Eindhoven University of Technology', context: 'The Electrical Engineering faculty needed an automated system to evaluate student work for Machine Learning for Signal Processing. Instructors wanted to provide students with freedom to experiment, but grading became complex and labor-intensive due to the variety of possible solution approaches.', approach: 'Development of an integrated system including:\n• Virtual testing environment for code execution\n• Parser for student code and documents\n• Syntax and performance validation\n• On-premise LLM for qualitative analysis\n• Automatic comparison with model solutions\n• Detailed feedback based on rubrics', result: 'Students receive detailed, personalized feedback at scale without additional burden on instructors. The system provides both quantitative (grades) and qualitative (improvement points) assessment with 99% data privacy as everything remains local. Instructors can now focus on substantive guidance rather than repetitive grading tasks.', tags: ['Education', 'Code Review', 'On-Premise', 'Automation'], metrics: ['100% data privacy with local LLMs', ' 7x faster feedback cycle (from 7 days to 1 day)', '+90% time savings for instructors (from many hours to 1 hour for all students)'] },
        { title: 'EXAMAI: Formative Oral Exam Preparation', client: 'Eindhoven University of Technology', context: 'Oral examinations are a valued component of many TU/e courses, offering direct interaction between students and examiners. However, they often lack structure, consistency, and objective quality control. For Advanced Actuator Design, instructors needed a scalable way to help students practice oral assessments while maintaining fairness and meaningful feedback, without increasing grading workload.', approach: 'Design and deployment of an AI-assisted conversational examination system including:\n• Language models trained on course-specific materials aligned with learning objectives\n• Real-time interactive dialogues where the AI asks course-relevant questions and adapts its line of inquiry\n• Structured, detailed feedback to help students identify areas for improvement\n• Formative assessment mode allowing students to practice before formal evaluation\n• Privacy-first architecture respecting transparency and inclusiveness', result: 'Students rehearse oral examinations through dynamic AI conversations and receive consistent, structured feedback that supports deeper learning. Educators gain a standardized framework that reduces subjectivity while lowering preparation workload. The pilot in Advanced Actuator Design provides practical insights into the technical, pedagogical, and ethical aspects of AI-assisted assessment, supporting educators rather than replacing them.', tags: ['Education', 'Conversational AI', 'Formative Assessment', 'On-Premise'], metrics: ['Deployed for Advanced Actuator Design at TU/e', 'Real-time adaptive oral exam dialogues', 'Structured formative feedback before formal evaluation', 'Privacy-first design for transparent, inclusive assessment'] },
        { title: 'Personalized City Guide System', client: 'Maps Untold', context: 'Maps Untold needed to provide travelers with personalized local recommendations that would be fully branded to their business partners with minimal manual effort. Creating custom city guides for each visitor manually was impossible to scale.', approach: 'Development of a sophisticated data pipeline including:\n• Dynamic search engine integration to discover local venues and attractions\n• Selenium-based automated browser for content extraction from business websites\n• Specialized crawlers for menu URLs, opening hours, and social media profiles\n• Multimodal AI model for image quality assessment and content categorization\n• Personalization engine to match traveler preferences with local recommendations', result: 'The system automatically provides travelers with personalized city guides featuring high-quality local recommendations, all branded to Maps Untold\'s business partners. Travelers receive custom recommendations based on their preferences, while business partners maintain their branding with zero additional effort, enabling rapid scaling across multiple cities worldwide.', tags: ['Personalization', 'Automation', 'Travel Tech', 'AI Vision'], metrics: ['10x faster city onboarding', '95% recommendation relevance', '80% cost reduction', '1000+ personalized guides daily'] },
        { title: 'CRM ↔ Planning Integration Platform', client: 'Renewable Partners', context: 'Renewable Partners faced inefficient manual processes for customer management, planning, and billing. Double data entry led to errors and delays, while onboarding new customers was time-consuming and communication was inconsistent.', approach: 'Development of a comprehensive integration ecosystem including:\n• Seamless connection between CRM and planning tools\n• Automated onboarding process for new customers\n• Internal dashboards for efficient customer management\n• Fully automated billing system\n• Automated customer communication via SMS\n• Web tools for retrieving energy labels', result: 'The system has completely streamlined the customer management process. New customers are now automatically onboarded, all relevant information is communicated promptly and consistently via SMS, and billing is fully automated. Staff can easily manage customer data through intuitive dashboards, while customers can retrieve energy labels themselves through the website.', tags: ['Integration', 'CRM', 'Automation', 'Customer Management'], metrics: ['100% automated onboarding', '90% reduction in administrative errors', '75% time savings in billing process', 'Improved customer satisfaction through consistent communication'] },
        { title: 'Privacy-first HR Assistant', client: 'Dr. Pitt', context: 'HR departments struggle with quickly finding relevant information in the extensive jungle of HR documents that develop over time. Employees frequently ask the same questions about policies, procedures, and regulations, burdening HR teams with repetitive information requests.', approach: 'Development of a privacy-first RAG system including:\n• Locally hosted LLM on VPS for complete data control\n• Advanced document parsing and indexing of HR documentation\n• Tiered access control where each user has access to information corresponding to their tier level\n• Semantic search through HR knowledge base\n• Intelligent answer generation with source references', result: 'HR teams are relieved from repetitive information requests and can focus on strategic HR tasks. Employees get immediate access to accurate, personalized information from HR documents, while privacy and compliance are ensured through local hosting. The system respects organizational hierarchy through tiered information access.', tags: ['HR', 'RAG', 'Privacy-first', 'On-Premise'], metrics: ['80% reduction in repetitive HR queries', '95% faster information delivery', '100% data privacy through local hosting', 'Tiered access control for all users'] },
        { title: 'Multi-Agent Blog Generation Platform', client: 'AgentTailor.ai (Internal)', context: 'Manual blog writing for content marketing is time-consuming and requires constant research, writing skills, and brand awareness. Maintaining a consistent blog with relevant, SEO-optimized content that aligns with brand values and target audience was a challenge that consumed significant time from the core team.', approach: 'Development of a multi-agent system with specialized agents:\n• Search Agent: Executes Google searches via Serper API for current information\n• Crawler Agent: Analyzes existing website content and blog posts for brand sensitivity\n• Writing Agent: Generates blogs based on audience, brand values, and content format\n• Image Generator: Creates appropriate visuals for the generated content\n• Supervisory Agent: Coordinates all agents and ensures quality and brand consistency', result: 'The platform automatically generates high-quality blogs that perfectly align with brand values, target audience, and desired tone-of-voice. Each blog is generated with specific parameters such as reading time, distribution channel, and CTA integration. The system considers existing content to prevent duplication and ensures SEO optimization by integrating current search results.', tags: ['Multi-Agent', 'Content Marketing', 'AI Writing', 'SEO'], metrics: ['90% time savings in content creation', 'Consistent brand message across all content', 'Automatic SEO optimization', 'Personalized content for every audience'] }
      ],
      blueprintTitle: 'Not sure where to start?',
      blueprintSub: 'Get the Automation Blueprint sample to identify your best opportunities.',
      blueprintCta: 'Get Automation Blueprint'
    },
    mailingPage: {
      heroBadge: 'Data-driven direct mail',
      heroCta: 'Book an intro call',
      segmentToggle: {
        label: 'Choose your audience',
        recentSales: 'Recently sold',
        propertyData: 'General property data'
      },
      segments: {
        recentSales: {
          heroTitle: 'Exclusive leads at the moment of purchase',
          heroSub: 'We find recently sold homes based on energy labels and other property data, and send personalized letters on your behalf: exclusive leads with full property information.',
          opportunity: {
            badge: 'Your service area',
            title: 'Opportunities in your region',
            subtitle: 'suitable homes were sold last week in your service area, ground-level, with moderate energy labels. New residents, exactly when the decision is made.',
            regionLabel: 'Example region',
            regionName: 'Utrecht-East',
            statNumber: '22',
            statLabel: 'suitable homes this week',
            tableTitle: 'Where the opportunities are, your service area this week',
            tableHeaders: ['Municipality', 'Sold', 'Opportunities (label ≤ C)', 'Opportunity score / week'],
            rows: [
              { municipality: 'Utrecht', sold: 12, opportunities: 9, score: 84 },
              { municipality: 'Zeist', sold: 6, opportunities: 5, score: 72 },
              { municipality: 'Bunnik', sold: 4, opportunities: 3, score: 65 },
              { municipality: 'Houten', sold: 4, opportunities: 3, score: 61 }
            ],
            footnote: 'Opportunity score per week = weighted index on sales volume, share of moderate energy labels, and floor area. Higher = greater opportunity this week. Example data for illustration.'
          },
          valueProp: {
            badge: 'Visible before the quote round',
            title: 'Those households, exclusively on your doorstep.',
            body: 'New homeowners spend 5× more on home improvements in the first 6 months and only then search for a service provider on marketplaces or Google. We send a personal letter on your behalf, before that. If the resident responds, the lead is exclusively yours, with property data. You only need to pick up when they call.'
          },
          letterMockup: {
            title: 'What the homeowner receives',
            addressee: 'To the residents of',
            address: 'Dorpsstraat 12, Utrecht',
            heading: 'Welcome to your new home',
            body: 'Congratulations on your home on Dorpsstraat. Moving is the perfect moment for home improvements, especially for a 1974 home with energy label D.\n\nWith the right upgrades you can significantly lower your energy bill and qualify for subsidies.',
            signature: 'Kind regards,\nLocal Specialist BV, your local partner'
          },
          leadMockup: {
            title: 'What you get back',
            leadName: 'The de Vries family',
            leadBadge: 'New lead',
            fields: [
              { label: 'Address', value: 'Dorpsstraat 12, Utrecht' },
              { label: 'Build year', value: '1974' },
              { label: 'Floor area', value: '118 m²' },
              { label: 'Energy label', value: 'D · suitable' },
              { label: 'Asking price', value: '€ 465,000' },
              { label: 'Interest', value: 'Home improvement' }
            ],
            exclusiveNote: 'Exclusively yours. One home, one service provider. No bidding war with 4 others like on marketplaces.'
          }
        },
        propertyData: {
          heroTitle: 'Targeted letters based on property data',
          heroSub: 'We select homes in your service area by energy label, parcel data and other public sources, and send personalized letters to owners who match your service.',
          opportunity: {
            badge: 'Your selection criteria',
            title: 'Homes that match your service',
            subtitle: 'homes in your service area meet your filters, for example moderate energy label, suitable parcel size or specific property characteristics. Targeted reach without cold calling.',
            regionLabel: 'Example region',
            regionName: 'Alblasserwaard',
            statNumber: '847',
            statLabel: 'matching properties',
            tableTitle: 'Breakdown by municipality, your selection this week',
            tableHeaders: ['Municipality', 'Properties', 'Match (label ≤ C)', 'Opportunity score / week'],
            rows: [
              { municipality: 'Alblasserdam', sold: 312, opportunities: 89, score: 78 },
              { municipality: 'Hardinxveld-Giessendam', sold: 198, opportunities: 54, score: 71 },
              { municipality: 'Papendrecht', sold: 176, opportunities: 48, score: 68 },
              { municipality: 'Sliedrecht', sold: 161, opportunities: 41, score: 64 }
            ],
            footnote: 'Opportunity score per week = weighted index on matches, energy label and parcel/property characteristics. Example data for illustration. Filters are aligned in the first conversation.'
          },
          valueProp: {
            badge: 'Data instead of cold calling',
            title: 'Thousands of homes, one targeted letter per address.',
            body: 'Instead of random acquisition, filter on property characteristics that matter: energy label, parcel size, build year or region. We enrich addresses with public data, write tailored letters and add a QR code. When someone scans, you know exactly who is interested, exclusively for you.'
          },
          letterMockup: {
            title: 'What the homeowner receives',
            addressee: 'To the residents of',
            address: 'Klaproosstraat 2, Bleskensgraaf',
            heading: 'Your property has more potential',
            body: 'Your home on Klaproosstraat stands out in our analysis: parcel size 350 m², energy label C. That opens opportunities for sustainability and value growth.\n\nScan the QR code for a no-obligation analysis tailored to your situation.',
            signature: 'Kind regards,\nLocal Specialist BV, your local partner'
          },
          leadMockup: {
            title: 'What you get back',
            leadName: 'The Jansen family',
            leadBadge: 'QR scan · lead',
            fields: [
              { label: 'Address', value: 'Klaproosstraat 2, Bleskensgraaf' },
              { label: 'Parcel size', value: '350 m²' },
              { label: 'Energy label', value: 'C · suitable' },
              { label: 'Unbuilt area', value: '350 m²' },
              { label: 'Asking price', value: '€ 385,000' },
              { label: 'Interest', value: 'Via QR scan' }
            ],
            exclusiveNote: 'Exclusively yours. One home, one service provider. Lead immediately after QR scan, with all available property data.'
          }
        }
      },
      fit: {
        badge: 'Who this works for',
        title: 'Does this sound like you?',
        items: [
          'You actively seek new customers',
          'You currently buy leads on marketplaces or via Google',
          'You serve residential homeowners'
        ]
      },
      comparison: {
        badge: 'Compare channels',
        title: 'What you pay per lead, and what you get',
        subtitle: 'Not the cheapest click. The only one that is exclusive and on time.',
        headers: ['Channel', 'What you get', 'Shared?', 'Cost'],
        rows: [
          { channel: 'Werkspot / Homedeal', gets: 'Form lead, cold. Pay even if you don\'t win', shared: 'with 3–5', cost: '€40–80 /lead' },
          { channel: 'Google Ads', gets: 'Click → form, no property data', shared: 'n/a', cost: '€80–140 /lead' },
          { channel: 'Trade show (VSK etc.)', gets: 'Visibility, shared attention', shared: 'mass', cost: '€3,000+ /show' },
          { channel: 'Own sales team', gets: 'Cold calling / acquisition', shared: 'n/a', cost: '€4,000+ /mo' },
          { channel: 'Agent Tailor', gets: 'Exclusive lead + property data, at the right moment', shared: 'no, only you', cost: '€3.75 /letter', highlight: true }
        ],
        footnote: 'Werkspot/Google from market benchmarks; trade show/sales team = estimates. Agent Tailor = €3.75 per letter (excl.).'
      },
      roi: {
        badge: 'Calculate yourself',
        title: 'From letters to revenue',
        subtitle: 'Set the number of letters and job value and see the results instantly.',
        lettersLabel: 'Letters / month',
        scanRateLabel: 'QR scan rate: 16%',
        scanRateHint: 'With a QR code on the letter we achieve a 16% scan rate',
        jobValueLabel: 'Average job value',
        jobValuePlaceholder: '6000',
        metrics: [
          { key: 'scans', label: 'QR scans / month' },
          { key: 'customers', label: 'new customers / month' },
          { key: 'letterCost', label: 'letter costs / month' },
          { key: 'revenue', label: 'extra revenue / year' }
        ],
        conversionNote: 'Conversion: 2% of sent letters become a customer',
        assumptions: 'In the pilot call we align conversion and job value with your own numbers.'
      },
      division: {
        badge: 'How it works',
        title: 'We do the search and data work, you do the human part.',
        body: 'Our technology finds the homes and writes the letters. You keep your time for the consultation and the job. A letter on the doormat: not an ad that gets clicked away, targeted to the address, not an algorithm.'
      },
      pilot: {
        badge: 'Pilot · exclusive in your area',
        title: 'Start with a tailored pilot',
        body: 'In a first conversation we map your service area, audience and capacity. Then we design a pilot together that fits what you need and can handle.',
        bullets: [
          'Response within 1 business day',
          'No obligations',
          'Volume and planning by agreement'
        ],
        cta: 'Book an intro call'
      },
      disclaimer: 'Example data for illustration. Company name, address and figures are fictional. Letters addressed to "the residents of", based on public sources.'
    }
  }
} as const;
